import SkinAPI from "@api/lol/Skin.api";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router";
import type IChampion from "../../shared/models/IChampion.model";
import type ISkin from "../../shared/models/ISkin.model";
import useAppLanguage from "@hooks/language/useAppLanguage";

export const useSkinSearch = () => {
  const [search, setSearch] = useState("");
  const [popularSkins, setPopularSkins] = useState<ISkin[]>([]);
  const [championsAndSkins, setChampionsAndSkins] = useState<IChampion[]>([]);
  const scrollRef = useRef<HTMLInputElement>(null);
  const [params] = useSearchParams();
  const { lang } = useAppLanguage();

  const filteredChampionsAndSkins = useMemo(
    () =>
      championsAndSkins.filter(
        (champion) =>
          champion.skins.some((skin) =>
            skin.name.toLowerCase().includes(search.toLowerCase()),
          ) || champion.name.toLowerCase().includes(search.toLowerCase()),
      ),
    [championsAndSkins, search],
  );

  const loadData = useCallback(() => {
    SkinAPI.getPopular().then((res) => setPopularSkins(res.data));

    SkinAPI.getSkinsGroupedByChampions().then((res) => {
      setChampionsAndSkins(res.data);
    });
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData, lang.currentLanguage]);

  useEffect(() => {
    if (scrollRef.current && params.get("scrollTo") === "search") {
      setTimeout(() => {
        scrollRef?.current?.scrollIntoView({
          block: "center",
          behavior: "smooth",
        });
      }, 0);
      setTimeout(() => {
        scrollRef.current?.focus();
      }, 600);
    }
  }, [params]);

  const handleScrollToSearch = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ block: "center" });
    }
  };

  return {
    loadData,
    search,
    setSearch,
    popularSkins,
    filteredChampionsAndSkins,
    scrollRef,
    handleScrollToSearch,
  };
};
